export enum RATING {
  STAR_FULL = "ratingStarFull",
  STAR_EMPTY = "ratingStarEmpty",
  STAR = "ratingStar",
  WRAPPER = "ratingWrapper",
  THANK_YOU_FOR_RATING = "thankYouForRating",
  COMMENT_IS_REQUIRED_ERROR = "ratingCommentRequiredError",
  CONFIRM_RATING = "ratingConfirmRatingButton",
  CANCEL = "ratingCancelButton",
  COMMENT_FIELD = "ratingCommentField",
  GO_TO_MY_CLEANINGS = "ratingGoToMyCleaningsButton",
  BAD_RATING_QUESTION = "badRatingQuestion",
  BAD_RATING_ANSWER = "badRatingAnswer",
  BAD_RATING_COMMENT = "badRatingComment",
  BAD_RATING_ATTACH_PICTURE = "badRatingAttachPicture",
  GOOD_RATING_QUESTION = "goodRatingQuestion",
  GOOD_RATING_ANSWER = "goodRatingAnswer",
  GOOD_RATING_COMMENT = "goodRatingComment",
  GOOD_RATING_ATTACH_PICTURE = "goodRatingAttachPicture",
}

export enum THANK_YOU_NEGATIVE {
  HEADER = "negativeHeader",
  DESCRIPTION = "negativeDescription",
  PHONE_INFO = "negativePhoneInfo",
}

export enum THANK_YOU_POSITIVE {
  HEADER = "positiveHeader",
  DESCRIPTION = "positiveDescription",
  SHARE_SECTION = "positiveShareSection",
}
